var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"animation-card",style:({ backgroundImage: 'url(' + require('@/assets/img/bg-bw.png') + ')' })}),_c('router-view'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }